import script from "./AdminSocialLibrary.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminSocialLibrary.vue?vue&type=script&setup=true&lang=js"

import "./AdminSocialLibrary.vue?vue&type=style&index=0&id=ef028fba&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ef028fba"]])

export default __exports__